<script lang="ts">
import { slide }   from 'svelte/transition'
import { replace } from 'svelte-spa-router'
import Icon from '@iconify/svelte'

import { _ } from '../i18n.svelte'
import { copyClipbord, isNotTextEmpty } from '../util.svelte'
import MessageCard from '../components/messageCard.svelte'
import CopyInput   from '../components/copyInput.svelte'

import HmacMD5 from 'crypto-js/hmac-md5'

const SECRET_WORD = '[***]'

type Params = { message: string }
export let params: Params
let paramMessage = params?.message ?? ''

let text = paramMessage;
let key = 'secret';

$: reResult      = /#([0-9a-zA-Z]{32})/gm.exec(text)
$: targetHash    = reResult?.length > 0 ? reResult[1] : ''
$: targetMessage = reResult?.length > 0 ? text.substring(0, Number(reResult.index)) : ''
$: numOfSecret   = (text.match(/\[\*\*\*\]/g) || []).length;

$: secretList = [...Array(numOfSecret)].map(() => '')

$: isReadyHash = targetHash.length > 0
$: isReadyMessage = targetMessage.length > 0 && numOfSecret > 0
$: isReady = isReadyHash && isReadyMessage

$: isDone = targetHash === desryptionHash
$: isRequirePassword = !secretList.includes('') && !isDone

const replaceSecretWord = (tmp: string, secretList: string[]) => {
    secretList.forEach((secret, index) => {
        if (secret === '') secret = `[No. ${index + 1}]`
        else secret = `[${secret}]`
        tmp = tmp.replace(/\[\*\*\*\]/, secret)
    })
    return tmp
}

$: desryptionMessage = replaceSecretWord(targetMessage, secretList)
$: desryptionHash = HmacMD5(desryptionMessage.trim(), key).toString();
</script>
<template lang="pug">
main
    section.section-message(transition:slide)
        .container.container-message
            +if('text.length === 0')
                h2.main__h2__text {_('TODO', '確認したいテキストを入力してください。')}
                +else()
                    h2.main__h2__text {_('confirmation_step0', 'Confirm this message.')}
            textarea.resolve-message__form-message__textarea.__placeholder-font-color__gray(
                rows="5"
                bind:value="{text}"
                placeholder="たとえばこんな[***]のメッセージを入力してください。\n↓ ハッシュ値もお忘れなく。\n#17640cb9f28e4ace01a68552fe406d5a"
            )

            +if('text.length !== 0 && !isReady')
                +if('!isReadyHash')
                    p {_('TODO', 'ハッシュ値が取得できませんでした。')}
                +if('!isReadyMessage')
                    p {_('TODO', 'メッセージが正しくありません。')}

    +if('text.length !== 0 && isReady')
            +if('!isDone')
                section.section-input(transition:slide)
                    .container.container-input
                        .resolve-input__section-title__text {_('confirmation_step1', 'Enter appropriate text in \'[***]\'.')}
                        +each('secretList as secret, i')
                            span No. { i + 1 }
                            textarea.resolve-input__form-message__textarea(rows="1" bind:value="{secret}")
                    
            +if('isRequirePassword')
                section.section-input(transition:slide)
                    .container.container-input.--password
                        .resolve-input__section-title__text.--password {_('TODO', '合言葉を入力してください。')}
                            input.resolve-input__form-password__input.__placeholder-font-color__gray(bind:value="{key}" placeholder="(DEFAULT: secret)")                            
                        +if('key.length > 0')
                            | {_('TODO', '[***]のテキストか合言葉が正しくありません。')}

            section.section-answer(class="{isDone ? '--done' : ''}" transition:slide)
                .container.container-answer
                    .resolve-answer__sample__wrapper
                        .resolve-answer__sample-message__text { desryptionMessage }
                        .resolve-answer__sample-hash__text { desryptionHash }
                    .resolve-answer__target-hash__wrapper
                        | Target: { targetHash }
            
            +if('targetHash === desryptionHash')
                section.section-goal(transition:slide)
                    container.container-goal
                        .resolve-goal__message__text
                            | ハッシュ値が一致しました！
                            | {_('TODO', '宣言内容が確認できました！')}
                        .resolve-goal__link__wrapper
                            a.resolve-goal__link__text(href="https://secret.koneta.click/#/answer/{encodeURIComponent(desryptionHash.trim())}/{encodeURIComponent(desryptionMessage.trim())}/{encodeURIComponent(key===''?'secret':key.trim())}")
                                | 確認済みページを表示する

</template>
<style lang="scss">
.section-message {
    color: var(--color-white);
    background-color: var(--color-twitter);
    .container-message {
        padding: 3rem 1rem;
        .resolve-message__form-message__textarea {
            width: 100%;
            padding: 2%;
            color: var(--color-white);
            font-size: 1rem;
            border: 1px solid #bebebe;
            border-radius: 10px;
            &::placeholder {
                color: var(--color-gray);   
            }
        }
    }
} 
.section-input {
    .container-input {
        padding: 3rem 1rem;
        &.--password {
            padding: 0 1rem 3rem;
        }
        .resolve-input__section-title__text {
            font-size: 1.1rem;
            font-weight: bold;
            &.--password {
                margin: 1.5rem 0 0;   
            }
        }
        .resolve-input__form-message__textarea {
            width: 100%;
            padding: 2%;
            font-size: 1rem;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
        }
        .resolve-input__form-password__input {
            width: 100%;
            padding: 2%;
            font-size: 1rem;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
        }
    }
}
.section-answer {
    border-top: 1px solid var(--color-border-line);
    .container-answer {
        padding: 3rem 1rem;
        .resolve-answer__sample__wrapper {
            width: 100%;
            max-width: 37rem;
            margin: 1rem auto 0;
            padding: 2rem 4rem;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
            .resolve-answer__sample-message__text {
                font-weight: bold;
            }
        }
        .resolve-answer__target-hash__wrapper {
            font-size: 0.8rem;
            text-align: center;
        }
    }
}
.section-goal {
    color: var(--color-white);
    background-color: var(--color-green);
    border: none;
    .container-goal {
        padding: 3rem 1rem;
        text-align: center;
        .resolve-goal__link__wrapper {
            margin: 1rem 0 0;
            .resolve-goal__link__text {
                color: var(--color-white);
            }
        }
    }
}
</style>
